import { routes } from "@shared-core/routing/routes";
import { SignedInIndex } from "../pages/shell/SignedInIndex";
import { SignedInLayout } from "../pages/shell/SignedInLayout";
import { SignInPage } from "../pages/sign-in/SignInPage";
import { PurchaseOrderPage } from "../pages/purchase-order/PurchaseOrderPage";
import { OrdersPage } from "../pages/orders/OrdersPage";
import { QuoteRequestPage } from "../pages/quote-request/QuoteRequestPage";
import { QuoteRequestsPage } from "../pages/quote-requests/QuoteRequestsPage";
import { InvoicesPage } from "../pages/invoices/InvoicesPage";
import { AccountPage } from "../pages/account/AccountPage";
import { PicksPage } from "../pages/picks/PicksPage";
import { PickPage } from "../pages/picks/PickPage";
import { GoodsInPage } from "../pages/goods-in/GoodsInPage";
import { AssessmentPage } from "../pages/company/AssessmentPage";
import { CompanyPage } from "../pages/company/CompanyPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { previewSignInRoutes } from "../pages/preview-sign-in/routes";

// Supplier portal routing. The whole app is the portal, on its own hostname
// (or under /supplier/ beside the staff app in a testing preview: the router's
// basename is the build's base).
//
// The purchase order page and the quote request page sit outside
// SignedInLayout: they are the pages with two ways in (brief §9). With a link
// token in the #fragment they render in the link chrome (no nav, one record);
// without one they render inside the signed-in shell, and a person who isn't
// signed in is sent to sign in. The lists, invoices, account, warehouse picks
// and goods in need a login.
export const routeConfig = [
  { path: routes.supplierSignIn.path, Component: SignInPage },
  {
    path: routes.supplierPurchaseOrder.path,
    Component: PurchaseOrderPage,
  },
  {
    path: routes.supplierQuoteRequest.path,
    Component: QuoteRequestPage,
  },
  {
    Component: SignedInLayout,
    children: [
      { index: true, Component: SignedInIndex },
      {
        path: routes.supplierOrders.path,
        Component: OrdersPage,
      },
      {
        path: routes.supplierQuoteRequests.path,
        Component: QuoteRequestsPage,
      },
      {
        path: routes.supplierInvoices.path,
        Component: InvoicesPage,
      },
      {
        path: routes.supplierAccount.path,
        Component: AccountPage,
      },
      { path: routes.supplierPicks.path, Component: PicksPage },
      { path: routes.supplierPick.path, Component: PickPage },
      { path: routes.supplierGoodsIn.path, Component: GoodsInPage },
      { path: routes.supplierCompany.path, Component: CompanyPage },
      { path: routes.supplierAssessment.path, Component: AssessmentPage },
    ],
  },
  // The new sign-in, clickable in mock mode, beside the pages it will replace (docs/features/portal-sign-in).
  ...previewSignInRoutes,
  { path: "*", Component: NotFoundPage },
];
